import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBehaviorTreeData } from "../../store/components/MarketExplorer.slice";
import TreeServices from "../../services/Tree.services";
import { checkIfhasSetToDisplayOnly, getCountryCode, getModuleCode, getModuleName } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { deepMergeObjects } from "../../utils/MainHelper";
import WorkerServices from "../../services/Worker.services";
import ConfigServices from "../../services/Config.services";

function useBehaviorSelectionLoading() {
    const dispatch = useDispatch();
    const [isLoading, setisLoading] = useState(true);
    const [percentage, setPercentage] = useState(0)
    const {
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);

    const {
        configuration: {
            selectedTarget
        }
    } = useSelector((state) => state.marketExplorer);
    const moduleCode = getModuleCode()

    const percentageCallBack = (percent) => { setPercentage(percent) }

    useEffect(() => {
        const { oiCode } = marketPackage.parent || {}
        if (oiCode === "pharma") {
            setisLoading(true);
            TreeServices.getBehavioralAttributes(undefined, undefined, percentageCallBack).then(async (response) => {
                // const countryCode = getCountryCode("enterprise");
                // const folderLockConfigSpecific = selectedTarget?.lockFolder?.[moduleCode]?.[countryCode];
                // const folderLockConfigAll = selectedTarget?.lockFolder?.[moduleCode]?.allcountry;
                // const moduleConfig = deepMergeObjects(folderLockConfigAll || {}, folderLockConfigSpecific || {});
                // const folderLockConfigAllCountry = moduleConfig?.allcountry;
                // const folderLockConfigSpecificCountry = moduleConfig?.[countryCode];
                // let folderLockConfig = deepMergeObjects(moduleConfig || {}, deepMergeObjects(folderLockConfigAllCountry || {}, folderLockConfigSpecificCountry || {}));

                const folderLockConfig = await ConfigServices.getFolderLockConfig({ module: getModuleName(), marketExplorerCode: selectedTarget?.code });

                if (["hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "icd10", "expertmedia"].includes(moduleCode)) {
                    const targetFocusData = response.find((child) => child.name === "Target Focus");
                    const knowledgeData = response.find((child) => child.name === "Knowledge Base");
                    let prm = null;

                    if (folderLockConfig) {
                        let dataToLock = null;
                        if (selectedTarget?.code === "target_focus") {
                            dataToLock = targetFocusData;
                        } else {
                            dataToLock = knowledgeData;
                        }
                        prm = WorkerServices.lockFolderBaseFromConfig([dataToLock.children,
                            folderLockConfig]).then((lockedFolder) => {
                                if (selectedTarget?.code === "target_focus") {
                                    targetFocusData.children = lockedFolder;
                                } else {
                                    knowledgeData.children = lockedFolder;
                                }
                            });
                    }
                    if (prm) {
                        await prm;
                    }
                    dispatch(setBehaviorTreeData([
                        knowledgeData,
                        targetFocusData
                    ]));
                    setisLoading(false);
                } else {
                    let prm = null;
                    if (folderLockConfig) {
                        prm = WorkerServices.lockFolderBaseFromConfig([response,
                            folderLockConfig])
                    } else {
                        prm = Promise.resolve(response)
                    }

                    prm.then(async (locked) => {
                        const filtered = await checkIfhasSetToDisplayOnly(locked, selectedTarget.code, selectedTarget)
                        dispatch(setBehaviorTreeData(filtered));
                        setisLoading(false);
                    })
                }
            });
        }
    }, [marketPackage.code, selectedTarget]);

    return { isLoading, percentage };
}

export default useBehaviorSelectionLoading;
